import { TFunction } from 'i18next'

// Backend enum → step1.* wizard key; the two multi-word enums do not match a
// plain lowercase of the value.
const STEP1_KEY_BY_TYPE: Record<string, string> = {
  APARTMENT: 'apartment',
  HOUSE: 'house',
  TOWNHOUSE: 'townhouse',
  DUPLEX: 'duplex',
  PART_OF_HOUSE: 'partOfHouse',
  ROOM: 'room',
  COMMERCIAL_PROPERTY: 'commercialProperty',
  PLOT: 'plot',
  GARAGE: 'garage',
}

export const propertyTypeLabel = (t: TFunction, type?: string): string => {
  if (!type) return ''
  const key = STEP1_KEY_BY_TYPE[type] ?? type.toLowerCase()
  return t(`step1.${key}`, { defaultValue: '' })
}
